// extracted by css-extract-rspack-plugin
export default {"root":"shared-module__root__txKCi","fontSmoothing":"shared-module__fontSmoothing__J3zLj"};